import React from 'react';

export default function Development() {
  return <div>This page is for the Development of components indivisully</div>;
}
